<template>
  <v-card class="elevation-1">
    <v-card-text>
      <v-form v-model="$v.valid" @submit.prevent="submit">
        <v-text-field
          v-model.trim="$v.formdata.name.$model"
          :error-messages="nameErrors"
          :label="formdata.label"
          :counter="formdata.counter"
          :prepend-icon="formdata.icon"
          :hint="formdata.hint"
          @input="$v.formdata.name.$touch()"
          @blur="$v.formdata.name.$touch()"
        />
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="warning" dark @click="clear">
        <v-icon left>fas fa-redo</v-icon>
        Clear
      </v-btn>
      <v-btn :disabled="$v.$invalid" color="primary" @click="submit()">
        <v-icon dark left>
          fas fa-save
        </v-icon>
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { validationMixin } from "vuelidate";
import { handleErrors } from "../../services/formErrors";
import Manufacturer from "../../models/Manufacturer";
export default {
  name: "ManufacturerFormNew",
  mixins: [validationMixin],
  validations: Manufacturer.validations,
  data() {
    return {
      formdata: new Manufacturer()
    };
  },
  computed: {
    nameErrors() {
      return handleErrors("formdata", "name", this);
    }
  },
  methods: {
    submit() {
      this.$v.$touch();
      Manufacturer
        .$post(this.formdata.toCreatePayload())
        .then(() => this.clear())
    },
    clear() {
      this.formdata = new Manufacturer();
      this.$v.$reset();
    }
  }
};
</script>
